// TODO: Move this into the design system as a variant on the sheet
// In the meantime, centralize these overrides so it's easier to reference where they
// are used
export const SHEET_OVERFLOW_HEIGHT = 96;

export const SHEET_SPACING_RESET = {
  padding: '0 !important',
  right: '0',
  sx: {
    '& > div, & > div > div, .chakra-modal__body': {
      height: '100%',
      padding: 0,
    },
    '& > div > div > div': {
      padding: 0,
    },
    header: {
      padding: 0,
      margin: 0,
      top: 0,
      zIndex: 100,
    },
    paddingBottom: `${SHEET_OVERFLOW_HEIGHT}px !important`,
  },
};

export const SHEET_HORIZONTAL_SPACING_RESET = {
  padding: '0 !important',
  right: '0',
  sx: {
    '& > div, & > div > div, .chakra-modal__body': {
      height: '100%',
      paddingX: 0,
    },
    '& > div > div > div': {
      paddingX: 0,
    },
    header: {
      paddingX: 0,
      margin: 0,
      top: 0,
      zIndex: 100,
    },
    paddingBottom: `${SHEET_OVERFLOW_HEIGHT}px !important`,
  },
};
